<!-- prettier-ignore -->
<div class="pagination-wrapper">
  @if (totalPages >= 1) {
    <nav class="page-links">
      <button (click)="changePage(1)" [disabled]="currentPage === 1">
        <app-icon
          name="pageFirst"
          height="1.25rem"
          width="1.25rem"
          color="var(--color-gray-700)"
        ></app-icon>
      </button>

      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
        <app-icon
          name="chevronLeft"
          height="1.25rem"
          width="1.25rem"
          color="var(--color-gray-700)"
        ></app-icon>
      </button>

      @for (page of visiblePages; track $index; let i = $index) {
        @if (typeof page === 'number') {
          <button
            (click)="changePage(page)"
            [class.active]="page === currentPage"
            [class.first-number]="i === 0"
            [class.last-number]="i === visiblePages.length - 1"
          >
            {{ page }}
          </button>
        } @else {
          <span class="ellipsis">…</span>
        }
      }

      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
        <app-icon
          name="chevronRight"
          height="1.25rem"
          width="1.25rem"
          color="var(--color-gray-700)"
        ></app-icon>
      </button>

      <button (click)="changePage(totalPages)" [disabled]="currentPage === totalPages">
        <app-icon
          name="pageLast"
          height="1.25rem"
          width="1.25rem"
          color="var(--color-gray-700)"
        ></app-icon>
      </button>
    </nav>
  }

  <div class="items-per-page">
    表示件数 :
    <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
      @for (option of itemsPerPageOptions; track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </div>
</div>
